import { Link } from "react-router-dom";
import { GlobeMark } from "./core";
import { openDownloadModal } from "../../lib/download";

/* Social column omitted — no real handles exist yet anywhere in the repo.
   Add one back the moment there's an actual Instagram/X/LinkedIn to link. */
const COLUMNS: {
  heading: string;
  links: { label: string; to?: string; action?: () => void }[];
}[] = [
  {
    heading: "Product",
    links: [
      { label: "Features", to: "/#why" },
      { label: "AI Planning", to: "/#ai" },
      { label: "Pricing", to: "/#pricing" },
      { label: "Download", action: openDownloadModal },
    ],
  },
  {
    heading: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Contact", to: "/contact" },
    ],
  },
  {
    heading: "Support",
    links: [
      { label: "Support Center", to: "/support" },
      { label: "Delete Account", to: "/delete-account" },
    ],
  },
  {
    heading: "Legal",
    links: [
      { label: "Privacy Policy", to: "/privacy" },
      { label: "Terms of Service", to: "/terms" },
      { label: "Security", to: "/security" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="cine-site-footer">
      <div className="cine-footer-columns">
        <div className="cine-footer-brand">
          <Link to="/" className="cine-logo" aria-label="Rovera home">
            <GlobeMark size={24} />
            Rovera
          </Link>
          <p>
            AI trip planning, offline maps, and shared memories — in one app.
          </p>
        </div>
        {COLUMNS.map((col) => (
          <div key={col.heading} className="cine-footer-col">
            <span>{col.heading}</span>
            <ul>
              {col.links.map((link) => (
                <li key={link.label}>
                  {link.action ? (
                    <button type="button" onClick={link.action}>
                      {link.label}
                    </button>
                  ) : (
                    <Link to={link.to!}>{link.label}</Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="cine-footer">
        <span>© {new Date().getFullYear()} Rovera. All rights reserved.</span>
      </div>
    </footer>
  );
}
